import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "module_item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, "Opciones", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn btn-primary" }, "Abrir")
], -1)

import ModuleDataValues from "./ModuleDataValues.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  result: Object,
  module: String
},
  setup(__props) {



function openInNovatrans(form: string | undefined, element: string) {
  var data = { formulario: form, elemento: element };
  var dataJson = JSON.stringify(data);
  window.chrome?.webview?.postMessage(dataJson);
  console.log(`open in Novatrans ${form} - ${element}`);
  return false;
}


return (_ctx: any,_cache: any) => {
  return (__props.result)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
        _createElementVNode("table", {
          class: _normalizeClass(["module_data w100", __props.result.length > 4 ? 'table_loadable' : 'table_completed'])
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.result[0]), (value, label) => {
                return _renderSlot(_ctx.$slots, "default", { key: value }, () => [
                  value
                    ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                        _createElementVNode("th", {
                          class: _normalizeClass(["module_data_field", label])
                        }, _toDisplayString(value), 3)
                      ])
                    : _createCommentVNode("", true)
                ])
              }), 128)),
              _hoisted_2
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result, (data) => {
              return (_openBlock(), _createElementBlock("tr", {
                onClick: ($event: any) => (openInNovatrans(__props.module, data.Id)),
                class: "module_item",
                key: data
              }, [
                _createVNode(ModuleDataValues, { data: data }, null, 8, ["data"]),
                _hoisted_4
              ], 8, _hoisted_3))
            }), 128))
          ])
        ], 2)
      ])
    : _createCommentVNode("", true)
}
}

})